import { useEffect } from 'react'
import { Route, Routes } from 'react-router-dom'
import './App.scss'
import './layout/flags/flags.css'
import './layout/layout.scss'
import { Provider } from 'react-redux'
import { store } from './redux/store'
import Notification from './components/Notification'
import LoginTeam from './pages/User/features/LoginTeam'
import AddTeamName from './pages/User/features/AddTeamName'
import QRCodeLogin from './pages/User/features/QRCodeLogin'
import Welcome from './pages/User/features/Welcome'
import QRCodeLoginValidate from './pages/User/features/QRCodeLoginValidate'
import QRCodeLoginFreeGame from './pages/User/features/QRCodeLoginFreeGame'
import Game from './pages/User/features/Game'
import GamePuzzle from './pages/User/features/GamePuzzle'
import FinalPuzzle from './pages/User/features/FinalPuzzle'
import Leaderboard from './pages/User/features/Leaderboard'
import ChooseLanguage from './pages/User/components/ChooseLanguage'
import ProtectedRoute from './components/ProtectedRoute'
import End from './pages/User/features/End'
import Instructions from './pages/User/features/Instructions'
import { useNetwork } from './hooks/useNetwork'
import { Dialog } from 'primereact/dialog'
import { useTranslation } from 'react-i18next'
import WellDone from './pages/User/features/WellDone'
import SkipPuzzle from './pages/User/features/SkipPuzzle'
import jwt_decode from 'jwt-decode'
import SomethingWentWrong from './pages/User/features/ErrorPage'
import ErrorBoundaryWrapper from './components/ErrorBoundaryWrapper'

const App = () => {
  const isOnline = useNetwork()
  const { t } = useTranslation()

  useEffect(() => {
    const token = localStorage.getItem('tokenCityHunt') ?? ''
    if (token) {
      const { UserName }: any = jwt_decode(token)
      document.title = UserName
    }
  }, [])
  return (
    <>
      <Provider store={store}>
        <Notification />
        <Routes>
          <Route
            index
            path="/"
            element={
              <ErrorBoundaryWrapper message="">
                <LoginTeam />
              </ErrorBoundaryWrapper>
            }
          />
          <Route path="/error" element={<SomethingWentWrong />} />
          <Route path="/add-team-name" element={<ProtectedRoute />}>
            <Route
              path="/add-team-name"
              element={
                <ErrorBoundaryWrapper message="">
                  <AddTeamName />
                </ErrorBoundaryWrapper>
              }
            />
          </Route>
          <Route path="/qr-code-login" element={<ProtectedRoute />}>
            <Route
              path="/qr-code-login"
              element={
                <ErrorBoundaryWrapper message="">
                  <QRCodeLogin />
                </ErrorBoundaryWrapper>
              }
            />
          </Route>
          <Route path="/choose-language" element={<ProtectedRoute />}>
            <Route
              path="/choose-language"
              element={
                <ErrorBoundaryWrapper message="">
                  <ChooseLanguage />
                </ErrorBoundaryWrapper>
              }
            />
          </Route>
          <Route path="/instructions" element={<ProtectedRoute />}>
            <Route
              path="/instructions"
              element={
                <ErrorBoundaryWrapper message="">
                  <Instructions />
                </ErrorBoundaryWrapper>
              }
            />
          </Route>
          <Route
            path="/qr-code-login-validate/:gameCode"
            element={
              <ErrorBoundaryWrapper message="">
                <QRCodeLoginValidate />
              </ErrorBoundaryWrapper>
            }
          />
          <Route
            path="/free-game/:gameId"
            element={
              <ErrorBoundaryWrapper message="">
                <QRCodeLoginFreeGame />
              </ErrorBoundaryWrapper>
            }
          />
          <Route path="/welcome" element={<ProtectedRoute />}>
            <Route
              path="/welcome"
              element={
                <ErrorBoundaryWrapper message="">
                  <Welcome />
                </ErrorBoundaryWrapper>
              }
            />
          </Route>
          <Route path="/game" element={<ProtectedRoute />}>
            <Route
              index
              element={
                <ErrorBoundaryWrapper message="">
                  <Game />
                </ErrorBoundaryWrapper>
              }
            />
            <Route
              path=":questionId/:localeId"
              element={
                <ErrorBoundaryWrapper message="">
                  <GamePuzzle />
                </ErrorBoundaryWrapper>
              }
            />
            <Route
              path=":questionId/:localeId/welldone"
              element={
                <ErrorBoundaryWrapper message="">
                  <WellDone />
                </ErrorBoundaryWrapper>
              }
            />
            <Route
              path=":questionId/:localeId/skip"
              element={
                <ErrorBoundaryWrapper message="">
                  <SkipPuzzle />
                </ErrorBoundaryWrapper>
              }
            />
            <Route
              path="final-puzzle/:localeId"
              element={
                <ErrorBoundaryWrapper message="">
                  <FinalPuzzle />
                </ErrorBoundaryWrapper>
              }
            />
          </Route>

          <Route path="/end" element={<ProtectedRoute />}>
            <Route
              path="/end"
              element={
                <ErrorBoundaryWrapper message="">
                  <End />
                </ErrorBoundaryWrapper>
              }
            />
          </Route>
          <Route path="/leaderboard" element={<ProtectedRoute />}>
            <Route
              path="/leaderboard"
              element={
                <ErrorBoundaryWrapper message="">
                  <Leaderboard />
                </ErrorBoundaryWrapper>
              }
            />
          </Route>
        </Routes>
      </Provider>
      {!isOnline && (
        <Dialog
          header={t('InternetConnection')}
          visible={!isOnline}
          style={{ width: '94vw', height: '30%' }}
          closable={false}
          onHide={() => null}
          headerStyle={{
            backgroundColor: '#000',
            color: '#fff',
          }}
        >
          <div className="flex flex-column text-center justify-content-center align-items-center">
            <p>{t('YouAreOffline')}</p>
          </div>
        </Dialog>
      )}
    </>
  )
}

export default App
